import { render, staticRenderFns } from "./cbank.vue?vue&type=template&id=b939a03c&scoped=true&"
import script from "./cbank.vue?vue&type=script&lang=js&"
export * from "./cbank.vue?vue&type=script&lang=js&"
import style0 from "./cbank.vue?vue&type=style&index=0&id=b939a03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b939a03c",
  null
  
)

export default component.exports